import {item} from './preOrderItem';

export const query = `query getRelatedItemsPreOrder($externalId: String!, $productIds: [String!]!, $withOptions: Boolean = false, $withPriceRange: Boolean = false) {
    appSettings(externalId: $externalId) {
      widgetSettings
    }
    catalog {
      relatedProducts(productIds: $productIds) {
         ${item}
      }
    }
  }
  `;
